/** Connectivity and session state: live, reconnecting, offline (local tier), syncing, synced.
 * Colour never carries the meaning alone: the dot shape and the label do. */
import { useTranslation } from "react-i18next";

export type ConnState = "live" | "reconnecting" | "offline" | "syncing" | "synced";

const tone: Record<ConnState, { color: string; glyph: string }> = {
  live: { color: "var(--live)", glyph: "●" },
  reconnecting: { color: "var(--reconnecting)", glyph: "◐" },
  offline: { color: "var(--offline)", glyph: "◌" },
  syncing: { color: "var(--reconnecting)", glyph: "↻" },
  synced: { color: "var(--live)", glyph: "✓" },
};

export function StatusBar({ state, detail }: { state: ConnState; detail?: string }) {
  const { t } = useTranslation();
  const emphasised = state === "reconnecting" || state === "offline";
  return (
    <div
      role="status"
      aria-live="polite"
      className={[
        "flex items-center gap-2 rounded-[var(--radius-control)] px-3 py-2 text-sm",
        emphasised ? "bg-[color:var(--surface)] shadow-sm" : "",
      ].join(" ")}
    >
      <span aria-hidden style={{ color: tone[state].color }}>{tone[state].glyph}</span>
      <span className="whitespace-nowrap font-medium">{t(`status.${state}`)}</span>
      {detail && <span className="text-[color:var(--ink-2)]">· {detail}</span>}
    </div>
  );
}
